import Stepper from "./Stepper";
import Step from "./Step";
import { createContext, useState, useEffect } from "react";
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { APIURL } from "../../../hoc/AxiosSetting/axios.js";
import axios from "axios";

export const FormContext = createContext();

function ImsAuditMainstage2() {
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [formData, setFormData] = useState({});
  const [companySessionSelection, setcompanySessionSelection] = useState(false);
  const history = useHistory();
  const { orgcode } = useParams()
  const [editData, seteditData] = useState(false)
  const [show, setShow] = useState(false)
  const typeofaddressed = [
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' }
  ]
  const typeofadequate = [
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' }
  ]
  const typeofsatisfactory = [
    { key: 'Yes', value: 'Yes' },
    { key: 'No', value: 'No' }
  ]
  const [initialValues, setInitialValues] = useState({
    orgCode: 0,
    address: "",
    siteofaddress: "",
    total: "",
    dateofaudit: new Date(),
    mobile: "",
    email: "",
    noofserver: "",
    noofwspclp: "",
    datacenterdetails: "",
    noofappluser: "",
    noofinfrauser: "",
    noofappdev: "",
    scope: "",
    auditobject: "",
    teamleader: "",
    teamleaderName: "",
    auditorOne: "",
    auditorOneName: "",
    auditorTwo: "",
    auditorTwoName: "",
    nabcbSicCode: "",
    nabcbSicCodeName: "",
    technicalexpert: "",
    technicalExpertName: "",
    areqquatedmandays: "No",
    istherechangeemployee: "No",
    istherechangescope: "No",
    isthereanyinforevent: "No",

    auditdate1: new Date(),
    auditdate2: new Date(),
    technicalexpert: "",
    technicalExpertName: "",

    stageOneAudit: "",
    stageTwoAudit: "",

    typeofaddressedone:"Yes",
    typeofadequateone:"Yes",
    remarkone:"",
    typeofaddressedtwo:"Yes",
    typeofadequatetwo:"Yes",
    remarktwo:"",
    typeofaddressedtwo1:"Yes",
    typeofadequatetwo1:"Yes",
    remarktwo1:"",
    typeofaddressedtwo2:"Yes",
    typeofadequatetwo2:"Yes",
    remarktwo2:"",
    typeofaddressedthree:"Yes",
    typeofadequatethree:"Yes",
    remarkthree:"",
    typeofaddressedthree1:"Yes",
    typeofadequatethree1:"Yes",
    remarkthree1:"",
    typeofaddressedthree2:"Yes",
    typeofadequatethree2:"Yes",
    remarkthree2:"",
    typeofaddressedfour:"Yes",
    typeofadequatefour:"Yes",
    remarkfour:"",
    typeofaddressedfour1:"Yes",
    typeofadequatefour1:"Yes",
    remarkfour1:"",
    typeofaddressedfour2:"Yes",
    typeofadequatefour2:"Yes",
    remarkfour2:"",
    typeofaddressedfour3:"Yes",
    typeofadequatefour3:"Yes",
    remarkfour3:"",
    typeofaddressedfour4:"Yes",
    typeofadequatefour4:"Yes",
    remarkfour4:"",
    typeofaddressedfour5:"Yes",
    typeofadequatefour5:"Yes",
    remarkfour5:"",
    typeofaddressedfour6:"Yes",
    typeofadequatefour6:"Yes",
    remarkfour6:"",
    typeofaddressedfive:"Yes",
    typeofadequatefive:"Yes",
    remarkfive:"",
    typeofaddressedsix:"Yes",
    typeofadequatesix:"Yes",
    remarksix:"",
    typeofaddressedseven:"Yes",
    typeofadequateseven:"Yes",
    remarkseven:"",
    typeofaddressedeight:"Yes",
    typeofadequateeight:"Yes",
    remarkeight:"",
    typeofaddressednine:"Yes",
    typeofadequatenine:"Yes",
    remarknine:"",
    typeofaddressednine1:"Yes",
    typeofadequatenine1:"Yes",
    remarknine1:"",
    typeofaddressednine2:"Yes",
    typeofadequatenine2:"Yes",
    remarknine2:"",
    typeofaddressedten:"Yes",
    typeofadequateten:"Yes",
    remarkten:"",
    typeofaddressedten1:"Yes",
    typeofadequateten1:"Yes",
    remarkten1:"",
    typeofaddressedeleven:"Yes",
    typeofadequateeleven:"Yes",
    remarkeleven:"",
    typeofaddressedtwelve:"Yes",
    typeofadequatetwelve:"Yes",
    remarktwelve:"",
    typeofaddressedthirteen:"Yes",
    typeofadequatethirteen:"Yes",
    remarkthirteen:"",
    typeofaddressedthirteen1:"Yes",
    typeofadequatethirteen1:"Yes",
    remarkthirteen1:"",
    typeofsatisfactory:"Yes",
    typeofsatisfactoryremark:"",
    typeofsatisfactory1:"Yes",
    typeofsatisfactoryremark1:"",
    typeofsatisfactory2:"Yes",
    typeofsatisfactoryremark2:"",
    typeofsatisfactory3:"Yes",
    typeofsatisfactoryremark3:"",
    typeofsatisfactory4:"Yes",
    typeofsatisfactoryremark4:"",
    typeofsatisfactory5:"Yes",
    typeofsatisfactoryremark5:"",
    typeofsatisfactory6:"Yes",
    typeofsatisfactoryremark6:"",
    typeofsatisfactory7:"Yes",
    typeofsatisfactoryremark7:"",
    typeofsatisfactory8:"Yes",
    typeofsatisfactoryremark8:"",
    typeofsatisfactory9:"Yes",
    typeofsatisfactoryremark9:"",
    typeofsatisfactory10:"Yes",
    typeofsatisfactoryremark10:"",
    typeofsatisfactory11:"Yes",
    typeofsatisfactoryremark11:"",
    typeofsatisfactory12:"Yes",
    typeofsatisfactoryremark12:"",
    typeofsatisfactory13:"Yes",
    typeofsatisfactoryremark13:"",
    typeofsatisfactory14:"Yes",
    typeofsatisfactoryremark14:"",
    
  });
  const [technicalExpertList, setTechnicalExpertList] = useState([{
    label: "",
    value: ""
  }])
  const [leadauditorList, setLeadauditorList] = useState([{
    label: "",
    value: ""
  }])
  const [assitAuditorList, setassitAuditorList] = useState([{
    label: "",
    value: ""
  }])
  const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
    onSuccess(data) {
      if (data.data.errorCode === 0) {
        setTechnicalExpertList(data.data.response)
      } else {
        var msg = 'Subject - ' + data.data.errorMsg;
        ToastInstance('Error', msg)
      }
    },
    onError(error) {

      ToastInstance('Error', 'Subject' + error)
    }
  })
  const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
    onSuccess(data) {

      if (data.data.errorCode === 0) {
        setassitAuditorList(data.data.response)

      } else {
        var msg = 'Subject - ' + data.data.errorMsg;
        ToastInstance('Error', msg)
      }
    },
    onError(error) {
      ToastInstance('Error', 'Subject' + error)
    }
  })
  const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
    onSuccess(data) {

      if (data.data.errorCode === 0) {
        setLeadauditorList(data.data.response)
      } else {
        var msg = 'Subject - ' + data.data.errorMsg;
        ToastInstance('Error', msg)
      }
    },
    onError(error) {
      ToastInstance('Error', 'Subject' + error)
    }
  })
  const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/imsstage2auditreport', params), {
    onSuccess(data) {
      if (data.data.errorCode === 0) {
        ToastInstance('Success', 'Stage 1 Audit Report Data Updated')
      } else {
        var msg = 'stage 1 audit report - ' + data.data.errorMsg;
        ToastInstance('Error', msg)
      }
    },
    onError(error) {
      ToastInstance('Error', 'Contract Review' + error)
    }
  })
  const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
    onSuccess(data) {

      if (data.data.errorCode === 0) {
        var tempInitialValues = data.data.response;
        tempInitialValues.siteofaddress = data.data.response.siteofaddress || "";
        tempInitialValues.auditobject = data.data.response.auditobject || "";
        tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
        tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
        tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;
        tempInitialValues.typeofaddressedone =tempInitialValues.typeofaddressedone || "Yes";
        tempInitialValues.typeofadequateone =tempInitialValues.typeofadequateone || "Yes";
        tempInitialValues.remarkone =tempInitialValues.remarkone || "";
        tempInitialValues.typeofaddressedtwo =tempInitialValues.typeofaddressedtwo || "Yes";
        tempInitialValues.typeofadequatetwo =tempInitialValues.typeofadequatetwo || "Yes";
        tempInitialValues.remarktwo =tempInitialValues.remarktwo || "";
        tempInitialValues.typeofaddressedtwo1 =tempInitialValues.typeofaddressedtwo1 || "Yes";
        tempInitialValues.typeofadequatetwo1 =tempInitialValues.typeofadequatetwo1 || "Yes";
        tempInitialValues.remarktwo1 =tempInitialValues.remarktwo1 || "";
        tempInitialValues.typeofaddressedtwo2 =tempInitialValues.typeofaddressedtwo2 || "Yes";
        tempInitialValues.typeofadequatetwo2 =tempInitialValues.typeofadequatetwo2 || "Yes";
        tempInitialValues.remarktwo2 =tempInitialValues.remarktwo2 || "";
        tempInitialValues.typeofaddressedthree =tempInitialValues.typeofaddressedthree || "Yes";
        tempInitialValues.typeofadequatethree =tempInitialValues.typeofadequatethree || "Yes";
        tempInitialValues.remarkthree =tempInitialValues.remarkthree || "";
        tempInitialValues.typeofaddressedthree1 =tempInitialValues.typeofaddressedthree1 || "Yes";
        tempInitialValues.typeofadequatethree1 =tempInitialValues.typeofadequatethree1 || "Yes";
        tempInitialValues.remarkthree1 =tempInitialValues.remarkthree1 || "";
        tempInitialValues.typeofaddressedthree2 =tempInitialValues.typeofaddressedthree2 || "Yes";
        tempInitialValues.typeofadequatethree2 =tempInitialValues.typeofadequatethree2 || "Yes";
        tempInitialValues.remarkthree2 =tempInitialValues.remarkthree2 || "";
        tempInitialValues.typeofaddressedfour =tempInitialValues.typeofaddressedfour || "Yes";
        tempInitialValues.typeofadequatefour =tempInitialValues.typeofadequatefour || "Yes";
        tempInitialValues.remarkfour =tempInitialValues.remarkfour || "";
        tempInitialValues.typeofaddressedfour1 =tempInitialValues.typeofaddressedfour1 || "Yes";
        tempInitialValues.typeofadequatefour1 =tempInitialValues.typeofadequatefour1 || "Yes";
        tempInitialValues.remarkfour1 =tempInitialValues.remarkfour1 || "";
        tempInitialValues.typeofaddressedfour2 =tempInitialValues.typeofaddressedfour2 || "Yes";
        tempInitialValues.typeofadequatefour2 =tempInitialValues.typeofadequatefour2 || "Yes";
        tempInitialValues.remarkfour2 =tempInitialValues.remarkfour2 || "";
        tempInitialValues.typeofaddressedfour3 =tempInitialValues.typeofaddressedfour3 || "Yes";
        tempInitialValues.typeofadequatefour3 =tempInitialValues.typeofadequatefour3 || "Yes";
        tempInitialValues.remarkfour3 =tempInitialValues.remarkfour3 || "";
        tempInitialValues.typeofaddressedfour4 =tempInitialValues.typeofaddressedfour4 || "Yes";
        tempInitialValues.typeofadequatefour4 =tempInitialValues.typeofadequatefour4 || "Yes";
        tempInitialValues.remarkfour4 =tempInitialValues.remarkfour4 || "";
        tempInitialValues.typeofaddressedfour5 =tempInitialValues.typeofaddressedfour5 || "Yes";
        tempInitialValues.typeofadequatefour5 =tempInitialValues.typeofadequatefour5 || "Yes";
        tempInitialValues.remarkfour5 =tempInitialValues.remarkfour5 || "";
        tempInitialValues.typeofaddressedfour6 =tempInitialValues.typeofaddressedfour6 || "Yes";
        tempInitialValues.typeofadequatefour6 =tempInitialValues.typeofadequatefour6 || "Yes";
        tempInitialValues.remarkfour6 =tempInitialValues.remarkfour6 || "";
        tempInitialValues.typeofaddressedfive =tempInitialValues.typeofaddressedfive || "Yes";
        tempInitialValues.typeofadequatefive =tempInitialValues.typeofadequatefive || "Yes";
        tempInitialValues.remarkfive =tempInitialValues.remarkfive || "";
        tempInitialValues.typeofaddressedsix =tempInitialValues.typeofaddressedsix || "Yes";
        tempInitialValues.typeofadequatesix =tempInitialValues.typeofadequatesix || "Yes";
        tempInitialValues.remarksix =tempInitialValues.remarksix || "";
        tempInitialValues.typeofaddressedseven =tempInitialValues.typeofaddressedseven || "Yes";
        tempInitialValues.typeofadequateseven =tempInitialValues.typeofadequateseven || "Yes";
        tempInitialValues.remarkseven =tempInitialValues.remarkseven || "";
        tempInitialValues.typeofaddressedeight =tempInitialValues.typeofaddressedeight || "Yes";
        tempInitialValues.typeofadequateeight =tempInitialValues.typeofadequateeight || "Yes";
        tempInitialValues.remarkeight =tempInitialValues.remarkeight || "";
        tempInitialValues.typeofaddressednine =tempInitialValues.typeofaddressednine || "Yes";
        tempInitialValues.typeofadequatenine =tempInitialValues.typeofadequatenine || "Yes";
        tempInitialValues.remarknine =tempInitialValues.remarknine || "";
        tempInitialValues.typeofaddressednine1 =tempInitialValues.typeofaddressednine1 || "Yes";
        tempInitialValues.typeofadequatenine1 =tempInitialValues.typeofadequatenine1 || "Yes";
        tempInitialValues.remarknine1 =tempInitialValues.remarknine1 || "";
        tempInitialValues.typeofaddressednine2 =tempInitialValues.typeofaddressednine2 || "Yes";
        tempInitialValues.typeofadequatenine2 =tempInitialValues.typeofadequatenine2 || "Yes";
        tempInitialValues.remarknine2 =tempInitialValues.remarknine2 || "";
        tempInitialValues.typeofaddressedten =tempInitialValues.typeofaddressedten || "Yes";
        tempInitialValues.typeofadequateten =tempInitialValues.typeofadequateten || "Yes";
        tempInitialValues.remarkten =tempInitialValues.remarkten || "";
        tempInitialValues.typeofaddressedten1 =tempInitialValues.typeofaddressedten1 || "Yes";
        tempInitialValues.typeofadequateten1 =tempInitialValues.typeofadequateten1 || "Yes";
        tempInitialValues.remarkten1 =tempInitialValues.remarkten1 || "";
        tempInitialValues.typeofaddressedeleven =tempInitialValues.typeofaddressedeleven || "Yes";
        tempInitialValues.typeofadequateeleven =tempInitialValues.typeofadequateeleven || "Yes";
        tempInitialValues.remarkeleven =tempInitialValues.remarkeleven || "";
        tempInitialValues.typeofaddressedtwelve =tempInitialValues.typeofaddressedtwelve || "Yes";
        tempInitialValues.typeofadequatetwelve =tempInitialValues.typeofadequatetwelve || "Yes";
        tempInitialValues.remarktwelve =tempInitialValues.remarktwelve || "";
        tempInitialValues.typeofaddressedthirteen =tempInitialValues.typeofaddressedthirteen || "Yes";
        tempInitialValues.typeofadequatethirteen =tempInitialValues.typeofadequatethirteen || "Yes";
        tempInitialValues.remarkthirteen =tempInitialValues.remarkthirteen || "";
        tempInitialValues.typeofaddressedthirteen1 =tempInitialValues.typeofaddressedthirteen1 || "Yes";
        tempInitialValues.typeofadequatethirteen1 =tempInitialValues.typeofadequatethirteen1 || "Yes";
        tempInitialValues.remarkthirteen1 =tempInitialValues.remarkthirteen1 || "";
        tempInitialValues.typeofsatisfactory =tempInitialValues.typeofsatisfactory || "Yes";
        tempInitialValues.typeofsatisfactoryremark =tempInitialValues.typeofsatisfactoryremark || "";
        tempInitialValues.typeofsatisfactory1 =tempInitialValues.typeofsatisfactory1 || "Yes";
        tempInitialValues.typeofsatisfactoryremark1 =tempInitialValues.typeofsatisfactoryremark1 || "";
        tempInitialValues.typeofsatisfactory2 =tempInitialValues.typeofsatisfactory2 || "Yes";
        tempInitialValues.typeofsatisfactoryremark2 =tempInitialValues.typeofsatisfactoryremark2 || "";
        tempInitialValues.typeofsatisfactory3 =tempInitialValues.typeofsatisfactory3 || "Yes";
        tempInitialValues.typeofsatisfactoryremark3 =tempInitialValues.typeofsatisfactoryremark3 || "";
        tempInitialValues.typeofsatisfactory4 =tempInitialValues.typeofsatisfactory4 || "Yes";
        tempInitialValues.typeofsatisfactoryremark4 =tempInitialValues.typeofsatisfactoryremark4 || "";
        tempInitialValues.typeofsatisfactory5 =tempInitialValues.typeofsatisfactory5 || "Yes";
        tempInitialValues.typeofsatisfactoryremark5 =tempInitialValues.typeofsatisfactoryremark5 || "";
        tempInitialValues.typeofsatisfactory6 =tempInitialValues.typeofsatisfactory6 || "Yes";
        tempInitialValues.typeofsatisfactoryremark6 =tempInitialValues.typeofsatisfactoryremark6 || "";
        tempInitialValues.typeofsatisfactory7 =tempInitialValues.typeofsatisfactory7 || "Yes";
        tempInitialValues.typeofsatisfactoryremark7 =tempInitialValues.typeofsatisfactoryremark7 || "";
        tempInitialValues.typeofsatisfactory8 =tempInitialValues.typeofsatisfactory8 || "Yes";
        tempInitialValues.typeofsatisfactoryremark8 =tempInitialValues.typeofsatisfactoryremark8 || "";
        tempInitialValues.typeofsatisfactory9 =tempInitialValues.typeofsatisfactory9 || "Yes";
        tempInitialValues.typeofsatisfactoryremark9 =tempInitialValues.typeofsatisfactoryremark9 || "";
        tempInitialValues.typeofsatisfactory10 =tempInitialValues.typeofsatisfactory10 || "Yes";
        tempInitialValues.typeofsatisfactoryremark10 =tempInitialValues.typeofsatisfactoryremark10 || "";
        tempInitialValues.typeofsatisfactory11 =tempInitialValues.typeofsatisfactory11 || "Yes";
        tempInitialValues.typeofsatisfactoryremark11 =tempInitialValues.typeofsatisfactoryremark11 || "";
        tempInitialValues.typeofsatisfactory12 =tempInitialValues.typeofsatisfactory12 || "Yes";
        tempInitialValues.typeofsatisfactoryremark12 =tempInitialValues.typeofsatisfactoryremark12 || "";
        tempInitialValues.typeofsatisfactory13 =tempInitialValues.typeofsatisfactory13 || "Yes";
        tempInitialValues.typeofsatisfactoryremark13 =tempInitialValues.typeofsatisfactoryremark13 || "";
        tempInitialValues.typeofsatisfactory14 =tempInitialValues.typeofsatisfactory14 || "Yes";
        tempInitialValues.typeofsatisfactoryremark14 =tempInitialValues.typeofsatisfactoryremark14 || "";

        tempInitialValues.nacecode = data.data.response.nabcbcode
        if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {

          mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
        }
        if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
          mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
        }
        if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
          mutationAssisAuditorDetails.mutate(tempInitialValues.nabcbcode)
        }


        setInitialValues(tempInitialValues)
      }
    },
    onError(error) {
      console.log('Got error from backend', error)
    }
  })

    
  const { data: OrgList, isLoading: companyListLoading } = useQuery(
    'listAuditPlan',
    () => Fetcher('get', '/api/clientaccess/get/listofcompaniesimsstage1audreport/' + localStorage.getItem("userCode"), {}))

    const { data: OrgListOrg, isLoading: orgLoading } = useQuery(
      'listRfq',
      () => Fetcher('get', '/api/typeoforg/get/typeoforgkeyvalue', {}))
  const getUrl = () => {
    const api = APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
    axios.get(api, { headers: { "Authorization": 'Bearer ' + localStorage.getItem("token") } })
      .then(Rfqdata => {
        if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
         
          console.log("tempdata 2024",Rfqdata.data.response)
          var tempData = Rfqdata.data.response
          tempData.dateofaudit = Date.parse(tempData.dateofaudit);
          tempData.auditdate1 = Date.parse(tempData.auditdate1);
          tempData.auditdate2 = Date.parse(tempData.auditdate2);


          
        
          setInitialValues(tempData)
          seteditData(true)
          if (tempData.nabcbcode && tempData.nabcbcode !== "") {
            mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
          }
          if (tempData.nacecode && tempData.nacecode !== "") {
            mutationTechnicalExpertDetails.mutate(tempData.nacecode)
          }
          if (tempData.nacecode && tempData.nacecode !== "") {
            mutationAssisAuditorDetails.mutate(tempData.nacecode)
          }
        }
      })
      .catch(err => {
        var string = JSON.stringify(err).split("/")[0]
        const regex = /401/g;
        const found = string.match(regex);

        if (found !== null) {
          console.log(err)
          window.location.href = "/signin"
        }


      })
  }
  const saveData = (values) => {
    mutation.mutate(values)
  }
  useEffect(() => {
    if (orgcode !== undefined) {
      console.log("orgcode 2092",orgcode);
      getUrl();

      const timeout = setTimeout(() => {
        setShow(true)
        setcompanySessionSelection(true);
      }, 5000)
  
      return () => clearTimeout(timeout)
  
    }
  }, [orgcode !== undefined,show]);
  if (companyListLoading || orgLoading) return <h1>Loading</h1>
  console.log("orgcode 2086",orgcode)
  console.log("initial orgcode 2086",initialValues.orgCode)
  // if(!show)return <h1>Loading</h1>

  return (
    <FormContext.Provider value={{
      activeStepIndex, setActiveStepIndex, formData, setFormData,companySessionSelection,
      technicalExpertList, setTechnicalExpertList,
      leadauditorList, setLeadauditorList,
      initialValues, setInitialValues,
      OrgList, OrgListOrg,mutationgetCompanyDetails,
      mutationTechnicalExpertDetails, mutationLeadAudiorDetails, mutationAssisAuditorDetails,
      saveData,
      assitAuditorList, setassitAuditorList,
      typeofaddressed,typeofadequate,typeofsatisfactory
    }}>
      <div className="w-screen h-screen flex flex-col items-center justify-start">
        <Stepper />
        <Step />
      </div>
    </FormContext.Provider>
  );
}

export default ImsAuditMainstage2;
